import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import config from '../../config';
import Swal from 'sweetalert2';

import Sidebar from '../../components/layout/Sidebar';
import ActivityCard from '../../components/customs/ActivityCard';
import ActivityBenefitCard from '../../components/customs/ActivityBenefitCard';
import BottomNav from '../../components/commons/BottomNav';
import Loader from '../../components/commons/Loader';
import Icon from '../../libraries/icons';

import { ToastContainer, notify } from '../../libraries/notifications';

import transactionsAction from '../../context/transactions/actions';
import { zonedTimeToUtc } from 'date-fns-tz'

import { history } from '../../routes';
import LayoutResponsive from '../../components/layout/LayoutResponsive';
import IconCoins from '../../components/customs/IconCoins';
import actions from '../../context/settings/actions';

class Activities extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.from = this.props.location.state?.from || { pathname: '/' };
    this.state = {
    activities : [],
    challengeActivities : [],
    benefitsActivities: [],
    selectedSection: 'activities',
    timeDelAction: 0,
    }
  }
  
  async componentDidMount() {
    this.setState({loading: true})
    await this.getSettings();
    await this.getActivities();
    this.setState({loading: false})
    await this.handleSectionChange();

  }
  handleSectionChange = async (e) => {
    const value = e.target.value;
    this.setState({ selectedSection: value, loading: true });

    if (value === 'activities') {
      await this.getActivities();
    } else if (value === 'challenges') {
      await this.getChallengesPoints();
    } else if (value === 'benefits') {
      await this.getBenefits();
    }
    this.setState({ loading: false });
  }
  getActivities = async ()=> {
    
    const user = this.props.location.state?.user || this.props.auth.user;
    const ownerParams = {
      type: [
        config.TRANSACTIONS.INITIATIVE.TYPE,
        config.TRANSACTIONS.ACTION.TYPE,
        config.TRANSACTIONS.BORROW.TYPE,
        config.TRANSACTIONS.BENEFIT.TYPE,
      ],
      status: [
        "attended",
        "pending",
        "postulated",
        "completed",
        "archived",
        // "accepted",
        "on_user",
        "on_owner",
        "review",
      ],
      created_by: user.id
    }
    await this.props.onGetOwnerActivities(ownerParams);
    const { activities } = this.props;
    let ownerActivities = activities.items

    if (activities.error) { 
      notify(this.t(activities.error.message));
    } else {
      const sourceParams = {
        type:config.TRANSACTIONS.BORROW.TYPE,
        source: user.id,
        status: [
          "accepted",
          "on_user",
          "on_owner",
          "review",
          "completed"
        ],
        owner: user.unique_id,
      }
      await this.props.onGetSourceActivities(sourceParams);
      const { activities } = this.props;
      let sourceActivities = activities.items
      if (activities.error) { 
        notify(this.t(activities.error.message));
      } else {
        let totalActivities = ownerActivities.concat(sourceActivities);
        totalActivities.sort((a, b) => 
           new Date(b.created_at) - new Date(a.created_at)
        );
        console.log("TOTAL ACTIVITIES", totalActivities);
        this.setState({ activities: totalActivities });
      }
    }
    
  }
  getBenefits = async () => {
    
    
    const user = this.props.location.state?.user || this.props.auth.user;
    const params = {
      type: config.TRANSACTIONS.BENEFIT.TYPE,
      // target: user.id,
      status: [
        "generated",
        "consumed",
        "reserved"
      ],
      created_by: user.id
    }
    await this.props.onGetOwnerActivities(params);
    const {activities} = this.props;
    let benefits = activities.items
    this.setState({benefitsActivities: benefits})
    

  }
  getChallengesPoints = async () => {
    
    const user = this.props.location.state?.user || this.props.auth.user;
    const params = {
      type: config.TRANSACTIONS.CHALLENGE.TYPE,
      sub_type: config.TRANSACTIONS.CHALLENGE.SUB_TYPE.COINS,
      target: user.id,
    }
      await this.props.onGetSourceActivities(params);
    const {activities} = this.props;
    this.setState({challengeActivities: activities.items})
    
  }

  getSettings = async () => {
    const params ={
      "code": "time_del_action",
      "type": "sharyco_settings",
      owner: this.props.auth.user.unique_id,
    }

    await this.props.onGetAllSettings(params);
    const error = this.props.settings.error;
    if(error){
      notify(this.t(error.message))
    }else{
      const settings = this.props.settings.items;
      if(settings.length == 0) return this.setState({timeDelAction: 0});
      const timeDelAction = settings[0].value;
      this.setState({timeDelAction: timeDelAction});
    }

  }

  deleteAction = async (id,created_by) => {
    const idUser= this.props.auth.user.id
    // validar que el usuario pueda eliminar solo sus acciones
    if(created_by !== idUser) return notify("No se pudo eliminar la accion")
    console.log("id", id)
    const swalWithStyle = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary mr-2',
        cancelButton: 'btn btn-ghost',
      },
      buttonsStyling: false
    })
     const result = await swalWithStyle.fire({
        title: this.t("¿Estás seguro que deseas eliminar la actividad?"),
        // text: "eliminar la actividad",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.t("Eliminar"),
        cancelButtonText: this.t("Cancelar"),
      })
      .then((result) => {
        return result
      });
    console.log('ANSWER', result);

    if (result && result.isConfirmed) {
      console.log("yes")
      await this.props.onDeleteActivity({id});
      const { activity } = this.props;
      if (activity.error) { 
        notify(this.t(activity.error.message));
      } else {
        this.getActivities()
      }
    }

  }
 
  gotoProduct = (p) => {
    let route = config.ROUTES.PRODUCTS.DETAIL
    let product_id = p.json_data.product ? p.json_data.product.id : p.json_data.offer.id
    if(p.sub_type === 'favor') route = config.ROUTES.FAVORS.DETAIL
    if(p.sub_type === 'service') route = config.ROUTES.SERVICES.DETAIL
    history.push({ pathname: route.replace(':id', product_id), state: { fromPath: config.ROUTES.USER.ACTIVITIES }})
  }
 
  render() {
    const { activities, user,  challengeActivities, benefitsActivities} = this.state;
    return (
      <LayoutResponsive
      main={{ className: "pb-48" }}
      header={{
        logo: true,
        //content: <NavButtonBar options={buttonBarUpper} active={topNav} onClick={this.onNavBarClick} />
      }}
      >
        {/* <Sidebar 
          header={{ 
            title: this.props.location.state?.user
              ? this.t("Actividad de " + this.props.location.state.user.json_data.first_name + " " + this.props.location.state.user.json_data.last_name)
              : this.t("Mi actividad"),
            className: '',
            // right: {
            //   action: () => {
            //     if(!this.props.location.state) history.push(config.ROUTES.HOME)
            //     else if (this.props.location.state?.user) {
            //       history.push(config.ROUTES.USER.PUBLIC_PROFILE.replace(":id", this.props.location.state.user.id))
            //     } else { 
            //       history.push(config.ROUTES.USER.PROFILE)
            //     }
            //   },
            //   icon: 'arrow_left'
            // }
          }}
        /> */}
        <ToastContainer/>
        <section className="p-4 mx-auto">
          <div className="mb-4">
            <select
              className="select select-bordered"
              value={this.state.selectedSection}
              onChange={this.handleSectionChange}
            >
              {/* <option >Selecciona una opción</option> */}
              <option  value="activities">Acciones/Préstamos</option>
              <option value="challenges">Puntos por Desafío</option>
              <option value="benefits">Beneficios</option>
            </select>
          </div>
        { this.state.loading && this.state.selectedSection !== '' && (<Loader/>) }
            { activities.length === 0 || challengeActivities === 0 && (
              <div className="text-center p-10 text-gray-400">
                <Icon className="h-14 w-14 mx-auto mb-2" name="loans" />
                <p className="mb-1">{this.t("No se registran actividades")}</p>
              </div>
            )}
          <div className="container bg-white shadow rounded-lg mb-10"> 
            {this.state.selectedSection === 'activities' && (
              <>
                {/* <h2 className='border-b border-base-200 my-2 ml-3'>Acciones/Préstamos:</h2>  */}
                  {
                    activities.map((activity,index)=> {
                      let actions = activity.type === config.TRANSACTIONS.ACTION.TYPE ? [{onClick: () => this.deleteAction(activity.id,activity.created_by), title: "Deshacer", disabled: this.state.loading}] : null
                      if(activity.type !== config.TRANSACTIONS.BENEFIT.TYPE){
                        return(
                          <ActivityCard
                          key={index}
                          /* time = {this.t("timeRemains", { date: new Date(zonedTimeToUtc(activity.created_at, timeZone)) })} */
                          activity={activity}
                          user ={user?.id}
                          statuses={config.STATUS.TRANSACTIONS}
                          types = {config.TRANSACTIONS.TYPES}
                          subtypes = {config.TRANSACTIONS.INITIATIVE.SUB_TYPES}
                          actions={this.props.location.state?.user ? [] : actions}
                          timeDelAction={this.state.timeDelAction}
                          onClick = {() => {
                              if(activity.type === 'initiative'){
                                if(activity.sub_type === 'donations'){
                                  history.push(config.ROUTES.DONATIONS.DETAIL.replace(":id", activity.json_data.initiative.id))
                                }  
                                if(activity.sub_type === 'recycling'){
                                  history.push(config.ROUTES.RECYCLING.DETAIL.replace(":id", activity.json_data.initiative.id))
                                }  
                                if(activity.sub_type === 'volunteering'){
                                  history.push(config.ROUTES.VOLUNTEERING.DETAIL.replace(":id", activity.json_data.initiative.id))
                                }  
                              }
                              if(activity.type === 'borrow'){
                                this.gotoProduct(activity)
                              }
                            }}
                        />
                        )
                      } 
                    }             
                  )
                }

              </>
            )}
            {this.state.selectedSection === 'challenges' && (
              <>
                {/* <h2 className='border-b border-base-200 my-2 ml-3'>Puntos por Desafío:</h2> */}
                  {challengeActivities?.map((act, index) => {
                    return (
                      <>
                        <div key={index} className="flex p-4 border-b border-base-200 gap-4">
                          <div className="max-w-[4rem] w-full overflow-hidden flex justify-center items-center object-contain">
                            <img src={act.json_data?.challenge.image} alt="" className='object-contain'/>
                          </div>
                          <div className='flex-1'>
                            <h5 className=''>Ganador: {act.json_data?.challenge.name}</h5>
                            <div className='flex justify-between mt-2'>
                              <IconCoins coins={act.json_data?.coins}/>
                            </div>
                            <div className="flex gap-3 justify-between items-center mt-2">
                              <h6 className=' text-gray-500'>{this.t("timeRemains", { date: new Date(act.created_at) })}</h6>
                            </div>
                          </div>
                        </div>
                      </>
                    )           
                  })}          
              </>
            )}
            {this.state.selectedSection === 'benefits' && (
              <>
                {/* <h2 className='border-b border-base-200 my-2 ml-3'>Beneficios:</h2> */}
                {
                  benefitsActivities.map((activity, index)=> {
                    return(
                      <>
                        <ActivityBenefitCard
                            key={index}
                            activity={activity}
                            statuses={config.STATUS.TRANSACTIONS}
                            types = {config.TRANSACTIONS.TYPES}
                            subtypes = {config.TRANSACTIONS.INITIATIVE.SUB_TYPES}
                            onClick = {() => {}}    
                            />
                      </>
                    )
                  })
                }
              </>
            )}       
          </div>
        </section>
        {/* <BottomNav/> */}
      </LayoutResponsive>
    ) 
  }
}

const mapStateToProps = state => {
  return {
    auth: state.users.auth,
    activities: state.transactions.list,
    activity: state.transactions.current,
    products: state.products.list,
    settings: state.settings.list,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetOwnerActivities: (ownerParams) => dispatch(transactionsAction.getAll(ownerParams)),
    onGetSourceActivities: (sourceParams) => dispatch(transactionsAction.getAll(sourceParams)),
    onDeleteActivity: (params) => dispatch(transactionsAction.del(params)),
    onGetAllSettings: (settingsParams) => dispatch(actions.getAll(settingsParams)),
  };
};

export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(Activities)) ;


